import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export function useRole() {
  const { data } = useSelfcare();
  return data?.roles;
}
